import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateService } from '../../services/template.service';
import { TranslateService } from '@ngx-translate/core';
import { CALENDAR_LOCALE, RD_DOC_TYPE } from '../../services/constant';
import * as moment from 'moment';
var SubmitToRdComponent = (function () {
    function SubmitToRdComponent(apiService, modalService, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.msgs = [];
        this.allBranch = true;
        this.allDocType = true;
        this.allDocumentType = [];
        this.allBranchSelected = [];
        this.selectedValues = [];
        this.indexArray = [];
        this.currentPage = 1;
        this.loading = false;
        this.loading_all_excel = false;
        this.cancel_loading_all_excel = false;
        this.loading_all_excel_message = '';
        this.no_data = true;
        this.value = 0;
        this.sum_docs_count = 0;
        this.loading_all_excel_progress = 0;
        this.errorMsg = '';
        this.monthList = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม',
            'พฤศจิกายน', 'ธันวาคม'];
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.yearList = [];
        this.allExcelCurrent = 0;
        this.index = 0;
        this.tableArray = [];
        this.branchList = null;
        this.allBranchList = null;
        this.docTypeList = null;
        this.loading_excel_report = false;
        this.is_TH = false;
        this.sortAscending = true;
        this.tableCol = [
            // { field: 'group', header: 'ประเภทธุรกิจ' },
            { field: 'branch', header: 'ชื่อสาขา' },
            { field: 'rd_doc_type', header: 'ประเภทเอกสาร' },
            // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
            { field: 'total_doc', header: 'จำนวนเอกสาร' }
        ];
        this.rd_doc_types = RD_DOC_TYPE;
        this.listInvNoIssueDate = {};
        this.sendToRdSuccess = false;
        this.sendToRdMessage = '';
    }
    SubmitToRdComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            if (event.lang === 'th') {
                _this.is_TH = true;
            }
            if (event.lang === 'en') {
                _this.is_TH = false;
            }
            _this.populateDropdown();
        });
        this.loadTexts();
        this.populateDropdown();
        this.searchData();
    };
    SubmitToRdComponent.prototype.loadTexts = function () {
        var _this = this;
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            var documentData = _this.template.getDropdown();
            documentData[0] = { label: _this.translate.instant('COMMON.ALL'), value: null };
            _this.rdDocumentType = documentData;
            _this.selectedRdDocumentType = null;
            _this.loadInput();
        });
    };
    Object.defineProperty(SubmitToRdComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitToRdComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    SubmitToRdComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SubmitToRdComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    SubmitToRdComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    SubmitToRdComponent.prototype.populateDropdown = function () {
        this.monthListDropdown = [];
        this.monthListDropdown.push({ label: this.translate.instant('MONTH.JANUARY'), value: 1 }, { label: this.translate.instant('MONTH.FEBRUARY'), value: 2 }, { label: this.translate.instant('MONTH.MARCH'), value: 3 }, { label: this.translate.instant('MONTH.APRIL'), value: 4 }, { label: this.translate.instant('MONTH.MAY'), value: 5 }, { label: this.translate.instant('MONTH.JUNE'), value: 6 }, { label: this.translate.instant('MONTH.JULY'), value: 7 }, { label: this.translate.instant('MONTH.AUGUST'), value: 8 }, { label: this.translate.instant('MONTH.SEPTEMBER'), value: 9 }, { label: this.translate.instant('MONTH.OCTOBER'), value: 10 }, { label: this.translate.instant('MONTH.NOVEMBER'), value: 11 }, { label: this.translate.instant('MONTH.DECEMBER'), value: 12 });
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
    };
    SubmitToRdComponent.prototype.canUserDownloadDoc = function () {
        // return this.authService.isAccountantAdmin();
        return true;
    };
    SubmitToRdComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.selectedCompany = null;
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.canDownloadZipOption = [{
                label: 'ทั้งหมด',
                value: null
            }, {
                label: 'เฉพาะที่ตรวจสอบจากบัญชีแล้ว',
                value: true
            }, {
                label: 'เฉพาะที่ยังไม่ได้ตรวจสอบ',
                value: false
            }];
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    SubmitToRdComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
        });
    };
    SubmitToRdComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchData(params);
    };
    SubmitToRdComponent.prototype.searchBranch = function (event) {
        var _this = this;
        if (this.branchList == null) {
            this.apiService.getBranch().subscribe(function (data) {
                _this.branchList = data;
                _this.branchSuggest = _this.filterData(event.query, 'full_name', _this.branchList);
            });
        }
        else {
            this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
    };
    SubmitToRdComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    SubmitToRdComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    SubmitToRdComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    SubmitToRdComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    SubmitToRdComponent.prototype.canUserApproveDoc = function () {
        return this.authService.isAccountant();
    };
    SubmitToRdComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        this.allBranchSelected = [];
        this.allDocumentType = [];
        _.forEach(this.branch, function (data) {
            // this.allBranchSelected = [];
            _this.allBranchSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
        var sniffTargetArr = [];
        if (this.selectedCompany) {
            sniffTargetArr.push('FILTER.COMPANY');
        }
        if (this.selectedBranch) {
            sniffTargetArr.push('FILTER.BRANCH');
        }
        if (this.selectedRdDocumentType) {
            sniffTargetArr.push('FILTER.DOCUMENT-TYPE');
        }
        if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
            sniffTargetArr.push('FILTER.DATE');
        }
        if (this.notSubmittedCompletely) {
            sniffTargetArr.push('SUBMIT-TO-RD.ITEMS-NOT-SENT-COMPLETELY');
        }
        var data = {
            not_submitted_completely: this.notSubmittedCompletely,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD'),
            group_id: this.selectedHomeproGroup,
            company_id: this.selectedCompany ? this.selectedCompany : null,
            can_download_zip: this.selectedCanDownloadZip,
            document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
            // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            branch_id: this.selectedBranch ? [this.selectedBranch] : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.apiService.postSubmitToRd(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.tableDataDisplay = _this.tableData;
            _this.sum_docs_count = result.sum_docs_count;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
            _this.selectedValues = [];
            for (var i = 0; i < _this.tableData.length; i++) {
                _this.selectedValues.push(false);
            }
            // copy array in "approved_but_not_in_ebxml_taxdataid_list" field from result.results to listOfTaxIdLists object
            // listOfTaxIdLists is an object of arrays
            _this.listOfTaxIdLists = result.results.map(function (item) {
                return item['not_in_ebxml_taxdataid_list'];
            });
            _this.listInvNoIssueDate = result.results.map(function (item) {
                return item['not_in_ebxml_inv_no_issue_dt_list'];
            });
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
        if (params == null) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    SubmitToRdComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    SubmitToRdComponent.prototype.confirmDocument = function (event, content, index, data) {
        event.currentTarget.blur();
        event.preventDefault();
        this.modalData = data;
        this.modal = this.modalService.open(content, { centered: true });
    };
    SubmitToRdComponent.prototype.confirm = function () {
        var _this = this;
        if (this.modalData.uploaded === false) {
            var params = {
                approved: true,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
        else {
            var params = {
                approved: false,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
    };
    SubmitToRdComponent.prototype.revertBack = function () {
        this.searchData();
        this.modal.close();
    };
    SubmitToRdComponent.prototype.clearData = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedCanDownloadZip = null;
        this.selectedRdDocumentType = null;
        this.selectedHomeproGroup = null;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.notSubmittedCompletely = false;
        this.selectedBranch = null;
        this.searchButtonClicked();
    };
    SubmitToRdComponent.prototype.getExcelFileName = function (data, headerIssueDateDash, index) {
        var file_name = 'submit_rd_report' + ' ' + headerIssueDateDash;
        return file_name + '.xlsx';
    };
    SubmitToRdComponent.prototype.clearBranch = function () {
        this.allBranchSelected = [];
    };
    SubmitToRdComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    SubmitToRdComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' '
                + this.translate.instant('COMMON.CORRECT');
        }
    };
    SubmitToRdComponent.prototype.selectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            // this.selectedValues[i] = (this.tableData[i].can_download_zip === true);
            this.selectedValues[i] = !this.tableData[i].submit_completely;
        }
    };
    SubmitToRdComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = false;
        }
    };
    SubmitToRdComponent.prototype.canSelectAll = function () {
        return this.tableData.filter(function (data) { return data.can_download_zip === true; }).length > 0;
    };
    SubmitToRdComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            return;
        }
        this.deselectAll();
    };
    SubmitToRdComponent.prototype.DownloadSelected = function (content) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                this.tableArray.push(this.tableData[i]);
                this.indexArray.push(i);
            }
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
            this.allExcelCount = this.tableArray.length;
            this.cancel_loading_all_excel = false;
            this.download(this.tableArray);
        }
    };
    SubmitToRdComponent.prototype.EnabledDownloadSelected = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    SubmitToRdComponent.prototype.DownloadExcelReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.apiService.getExcelReport(params).subscribe(function (obj) {
            var filename = 'tax_report_' + _this.selectedMonth + '_' + _this.selectedYear + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.loading_excel_report = false;
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    SubmitToRdComponent.prototype.download = function (tableArray) {
        var _this = this;
        // check if tableArray is empty
        if (!Array.isArray(tableArray) || !tableArray.length) {
            this.loading_all_excel = false;
            this.loading_all_excel_message = 'Download ' + this.translate.instant('COMMON.COMPLETE');
            for (var i = 0; i < tableArray.length; i++) {
                tableArray[i].uploaded = true;
            }
            return;
        }
        if (this.cancel_loading_all_excel) {
            return;
        }
        this.loading_all_excel = true;
        var dateArray = tableArray[0].header_issue_date.split('/');
        var headerIssueDay = dateArray[0];
        var headerIssueMonth = dateArray[1];
        var headerIssueYear = dateArray[2];
        var headerIssueDateDash = headerIssueYear + '-' + headerIssueMonth + '-' + headerIssueDay;
        var params = {
            header_issue_dt: headerIssueDateDash,
            rd_document_type: tableArray[0].rd_document_type,
            corporate_branch: tableArray[0].corporate_branch,
            group: tableArray[0].group,
            document_type: tableArray[0].document_type,
        };
        this.apiService.getAllExcelFile(params).subscribe(function (obj) {
            if (_this.cancel_loading_all_excel) {
                return;
            }
            // remove the first element in indexArray and store the value in the variable index
            var downloadIndex = _this.indexArray.shift();
            var filename = _this.getExcelFileName(tableArray[0], headerIssueDateDash, downloadIndex + 1);
            _this.apiService.createDownloadFile(obj, filename);
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.allExcelCurrent++;
            _this.loading_all_excel_progress = (_this.allExcelCurrent / _this.allExcelCount) * 100;
            // removes the first element in tableArray
            tableArray.shift();
            setTimeout(function () {
                _this.download(tableArray);
            }, 1000);
        }, function (error) {
            _this.loading_all_excel = false;
            _this.loading_all_excel_message = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    SubmitToRdComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_excel = true;
        this.loading_all_excel = false;
        this.allExcelCurrent = 0;
        this.loading_all_excel_progress = 0;
        this.searchButtonClicked();
    };
    SubmitToRdComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
        // this.searchData();
    };
    SubmitToRdComponent.prototype.submitCheckedToRd = function (content) {
        var _this = this;
        var taxDataIdSet = new Set();
        var invNoIssueDateSet = new Set();
        // get only indexes that have been selected
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                for (var j = 0; j < this.listOfTaxIdLists[i].length; j++) {
                    taxDataIdSet.add(this.listOfTaxIdLists[i][j]);
                    invNoIssueDateSet.add(this.listInvNoIssueDate[i][j]);
                }
            }
        }
        var taxDataIdArray = Array.from(taxDataIdSet.values());
        if (taxDataIdArray.length === 0) {
            this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.NO-DATA');
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
        }
        else {
            var params = {
                taxDataIdArray: taxDataIdArray
            };
            this.apiService.submitCheckedToRd(params).subscribe(function (result) {
                _this.sendToRdMessage = _this.translate.instant('SUBMIT-TO-RD.SUBMIT-ERROR');
                if (result.message === 'Submit to RD successful') {
                    _this.sendToRdMessage = _this.translate.instant('SUBMIT-TO-RD.SUBMIT-SUCCESS');
                }
                _this.modal = _this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
                for (var _i = 0, _a = Array.from(invNoIssueDateSet); _i < _a.length; _i++) {
                    var invNoIssueDate = _a[_i];
                    _this.sniff('SUBMIT_RD', invNoIssueDate);
                }
            }, function (error) {
            });
        }
    };
    SubmitToRdComponent.prototype.sortColumn = function (columnName) {
        if (this.sortAscending) {
            this.sortAscending = false;
            this.tableDataDisplay = this.tableData.sort(function (a, b) {
                // handle null value
                if (a[columnName] !== null && b[columnName] === null) {
                    return 1;
                }
                if (a[columnName] === null && b[columnName] !== null) {
                    return -1;
                }
                if (a[columnName] === null && b[columnName] === null) {
                    return 0;
                }
                return a[columnName] < b[columnName] ? -1 : a[columnName] > b[columnName] ? 1 : 0;
            });
        }
        else {
            this.sortAscending = true;
            this.tableDataDisplay = this.tableData.sort(function (a, b) {
                // handle null value
                if (a[columnName] !== null && b[columnName] === null) {
                    return -1;
                }
                if (a[columnName] === null && b[columnName] !== null) {
                    return 1;
                }
                if (a[columnName] === null && b[columnName] === null) {
                    return 0;
                }
                return a[columnName] < b[columnName] ? 1 : a[columnName] > b[columnName] ? -1 : 0;
            });
        }
    };
    SubmitToRdComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'SUBMIT_RD',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    SubmitToRdComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return SubmitToRdComponent;
}());
export { SubmitToRdComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.component.ts.pre-build-optimizer.js